define('home/templates/homepageFollowingModule',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var alias1=depth0 != null ? depth0 : {}, alias2=container.escapeExpression;

  return "<div class=\"aside__subheadings\">\n<h2 class=\"text-subheading\">"
    + alias2(helpers.gettext.call(alias1,"Following",{"name":"gettext","hash":{},"data":data}))
    + "</h2>\n</div>\n<div class=\"aside__wrap\">\n<div data-role=\"forums\"></div>\n<a href=\"/home/channels/\" class=\"nav-lnk -color-muted\">\n<div class=\"nav-lnk__blk\">"
    + alias2(helpers.gettext.call(alias1,"See All Following",{"name":"gettext","hash":{},"data":data}))
    + "</div>\n<div class=\"nav-lnk__pointer\">\n<span class=\"icon icon-right-bracket\"></span>\n</div>\n</a>\n</div>\n";
},"useData":true})

});
